// Cravy Home - "Why people love it" v2: each of the three tilted cards can show a photo
// OR a video (4:5). Registered as data-slice="why2". The original `why` component in
// cravy-sections2.js is untouched: remove the <script> tag for this file from
// sections/cr-home-why.liquid and set data-slice back to "why" to restore the old behaviour.
// Uses globals from earlier scripts (read at render time): React, H, P, useIsMobile, Reveal.
(function () {
  window.CravyHome = window.CravyHome || {};

  // Pick the mp4 source closest to (and not below) 720p, else the largest.
  function pickSrc(list) {
    var mp = (list || []).filter(function (s) { return s && s.f === 'mp4' && s.url; })
      .sort(function (a, b) { return a.h - b.h; });
    if (!mp.length) return '';
    for (var i = 0; i < mp.length; i++) if (mp[i].h >= 720) return mp[i].url;
    return mp[mp.length - 1].url;
  }

  function VideoCard(props) {
    var h = React.createElement;
    var ref = React.useRef(null);
    var ms = React.useState(true);
    var muted = ms[0], setMuted = ms[1];
    React.useEffect(function () {
      var v = ref.current;
      if (!v) return;
      v.muted = muted;
    }, [muted]);
    React.useEffect(function () {
      var v = ref.current;
      if (!v) return;
      v.muted = true;
      v.defaultMuted = true;
      var go = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      if (!('IntersectionObserver' in window)) { go(); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) go(); else v.pause(); });
      }, { threshold: 0.25 });
      io.observe(v);
      return function () { io.disconnect(); };
    }, [props.src]);
    return h(React.Fragment, null,
      h('video', {
        ref: ref,
        src: props.src,
        poster: props.poster || undefined,
        loop: true,
        playsInline: true,
        autoPlay: true,
        preload: 'metadata',
        style: { position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', display: 'block' }
      }),
      h('button', {
        type: 'button',
        'aria-label': muted ? 'Unmute video' : 'Mute video',
        onClick: function (e) { e.preventDefault(); e.stopPropagation(); setMuted(function (m) { return !m; }); },
        style: {
          position: 'absolute', right: 12, bottom: 12, width: 38, height: 38, borderRadius: '50%',
          background: 'rgba(0,0,0,0.45)', border: 'none', padding: 0, cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }
      },
      h('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: '#fff' },
        muted
          ? h('path', { d: 'M3 9v6h4l5 4V5L7 9H3zm13.6 3l2.4-2.4-1.4-1.4-2.4 2.4-2.4-2.4-1.4 1.4 2.4 2.4-2.4 2.4 1.4 1.4 2.4-2.4 2.4 2.4 1.4-1.4z' })
          : h('path', { d: 'M3 9v6h4l5 4V5L7 9H3zm13.5 3a4.5 4.5 0 0 0-2.5-4v8a4.5 4.5 0 0 0 2.5-4z' }))));
  }

  function WhyPeople2(props) {
    var h = React.createElement;
    var c = props.cfg || {};
    var m = useIsMobile();
    var bg = P(c.bg, 'var(--cravy-white)'),
      accent = P(c.accent, 'var(--cravy-red)'),
      headColor = P(c.heading_color, '#000000');
    var pos = [
      { id: 'why-1', top: '2%', left: '-16%', w: '46%', rot: -8, z: 1 },
      { id: 'why-2', top: '0%', left: '30%', w: '54%', rot: 7, z: 3 },
      { id: 'why-3', top: '38%', left: '8%', w: '48%', rot: -3, z: 2 }
    ];
    var cards = pos.map(function (p, i) {
      var n = i + 1;
      var vsrc = pickSrc(c['vid' + n]);
      var wantVideo = P(c['media' + n], 'photo') === 'video' && !!vsrc;
      return Object.assign({}, p, {
        ar: '4/5',
        img: P(c['img' + n], ''),
        video: wantVideo ? vsrc : '',
        poster: P(c['poster' + n], '') || P(c['img' + n], '')
      });
    });
    return h('section', {
      'data-screen-label': 'Why people love it',
      style: {
        background: bg, position: 'relative', zIndex: 0, overflow: 'hidden',
        minHeight: m ? 'auto' : '100vh', display: 'grid',
        gridTemplateColumns: m ? '1fr' : '1.15fr 1fr',
        gap: 'clamp(24px,3vw,60px)', padding: 'clamp(50px,7vh,90px) clamp(20px,5vw,80px)',
        boxSizing: 'border-box', alignItems: 'stretch'
      }
    },
    h('div', {
      style: m ? { display: 'flex', flexDirection: 'column', gap: 14, padding: '4px 0' }
        : { position: 'relative', minHeight: 'clamp(520px,88vh,900px)' }
    }, cards.map(function (cd, i) {
      return h('div', {
        key: cd.id,
        style: m ? {
          width: '58%', alignSelf: i % 2 ? 'flex-end' : 'flex-start',
          transform: 'rotate(' + (cd.rot * 0.6) + 'deg)', background: '#fff', borderRadius: 18,
          padding: 10, boxSizing: 'border-box', boxShadow: '0 24px 50px rgba(0,0,0,0.14)'
        } : {
          position: 'absolute', top: cd.top, left: cd.left, width: cd.w, zIndex: cd.z,
          transform: 'rotate(' + cd.rot + 'deg)', background: '#fff', borderRadius: 22,
          padding: 14, boxSizing: 'border-box', boxShadow: '0 24px 50px rgba(0,0,0,0.14)'
        }
      },
      h('div', {
        style: { position: 'relative', borderRadius: 14, overflow: 'hidden', aspectRatio: cd.ar, background: 'var(--cravy-yellow)' }
      },
      cd.video
        ? h(VideoCard, { src: cd.video, poster: cd.poster })
        : h('image-slot', {
          id: cd.id, shape: 'rounded', radius: '14', fit: 'cover', src: cd.img,
          placeholder: 'Drop a photo or video still', style: { width: '100%', height: '100%' }
        })));
    })),
    h('div', {
      style: { display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: m ? 'auto' : 'clamp(520px,80vh,900px)' }
    },
    h(Reveal, { kind: 'up' },
      h('h2', {
        // Mobile: same size / tracking / line-height as the other major home headings (e.g. "The open secret").
        // Desktop: same size / line-height / tracking as the "Restaurant quality" statement words.
        style: { margin: '0 0 22px', color: headColor, fontSize: m ? 'clamp(52px,15vw,72px)' : 'clamp(64px,9.5vw,150px)', lineHeight: m ? 0.92 : 0.82, letterSpacing: m ? '-4px' : '-0.09em' },
        dangerouslySetInnerHTML: H(P(c.heading, 'Less time cooking\nMore time together'))
      }),
      h('p', {
        style: { margin: 0, maxWidth: 520, fontFamily: 'var(--font-body)', fontWeight: 500, fontSize: 'clamp(15px,1.3vw,21px)', lineHeight: 1.35, color: 'var(--cravy-maroon)' },
        dangerouslySetInnerHTML: H(P(c.body, 'Great moments shouldn’t be spent standing over the stove. Cravy gets you back to the table faster with restaurant-quality fries ready in minutes.'))
      }),
      h('div', {
        style: { display: 'flex', flexDirection: m ? 'column' : 'row', alignItems: m ? 'flex-start' : 'center', gap: 18, marginTop: 34, fontFamily: 'var(--font-body)' }
      },
      h('a', {
        href: P(c.btn_link, '/collections/all'), className: 'whybtn',
        style: { display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', textDecoration: 'none' }
      },
      h('span', { style: { width: 46, height: 46, borderRadius: '50%', background: accent, display: 'flex', alignItems: 'center', justifyContent: 'center' } },
        h('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: '#fff', strokeWidth: 2.5 },
          h('path', { d: 'M7 17L17 7M9 7h8v8' }))),
      h('span', { style: { background: accent, color: '#fff', fontWeight: 700, fontSize: 'clamp(16px,1.3vw,21px)', padding: '12px 26px', borderRadius: 999 } }, P(c.btn_text, 'Buy now'))),
      h('span', { style: { display: 'flex', alignItems: 'center', gap: 10 } },
        h('span', { style: { color: accent, fontSize: 19, letterSpacing: 2 } }, '★★★★☆'),
        h('a', { href: '#reviews', style: { fontWeight: 600, fontSize: 14, color: 'var(--cravy-maroon)' } }, P(c.reviews_text, '3158 Reviews'))))),
    h('div', {
      style: m ? { textAlign: 'center', color: 'var(--cravy-maroon)', marginTop: 34 }
        : { position: 'absolute', bottom: 'clamp(20px,5vh,50px)', right: 'clamp(20px,4vw,80px)', textAlign: 'center', color: 'var(--cravy-maroon)' }
    },
    h('div', {
      style: { fontFamily: 'var(--font-body)', fontStyle: 'italic', fontWeight: 600, fontSize: 20, transform: 'rotate(-6deg)' },
      dangerouslySetInnerHTML: H(P(c.note, 'why people\nlove it'))
    }),
    h('svg', { width: 52, height: 74, viewBox: '0 0 52 74', fill: 'none', stroke: 'var(--cravy-maroon)', strokeWidth: 2.5, strokeLinecap: 'round', style: { marginTop: 6 } },
      h('path', { d: 'M44 4 C 20 18, 8 36, 10 62' }),
      h('path', { d: 'M3 52 L 10 63 L 20 57' })))));
  }

  window.CravyHome.why2 = WhyPeople2;
})();
